import { CalendarIcon } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

function toDate(v) {
  if (!v) return undefined;
  const d = new Date(v.length <= 10 ? v + "T00:00:00" : v);
  return isNaN(d) ? undefined : d;
}
function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default function DatePicker({ value, onChange, placeholder = "Pilih tanggal" }) {
  const selected = toDate(value);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="date-picker-trigger"
          className="w-full flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 text-sm text-left hover:border-dlh-green focus:outline-none focus:ring-2 focus:ring-dlh-orange bg-white">
          <CalendarIcon className="h-4 w-4 text-gray-400 shrink-0" />
          <span className={selected ? "text-gray-800" : "text-gray-400"}>
            {selected ? `${selected.getDate()} ${BULAN[selected.getMonth()]} ${selected.getFullYear()}` : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} onSelect={(d) => onChange(d ? toISO(d) : "")} initialFocus />
        {selected && (
          <button type="button" onClick={() => onChange("")} className="w-full border-t text-xs text-gray-500 hover:text-red-600 py-2">Hapus tanggal</button>
        )}
      </PopoverContent>
    </Popover>
  );
}
